if (process.env.NODE_ENV === 'development') {
    if (!ScreenLargeEnough) {
        require('./styles.basic.scss');
    } else {
        require('./styles.enhanced.scss');
    }
}

require('./patterns/molecules/video/video');
require('./patterns/molecules/slider/slider');
require('./patterns/organisms/form/login');
